export default __webpack_public_path__ + "static/Plots0030-69d0f52853bfba6e0a4470ff269af75d.jpg";